import React from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  Skeleton,
  FormHelperText,
} from '@mui/material';

const CpdDropdown = ({
  sx = {},
  options = [],
  value = '',
  onChange,
  label = 'Select',
  size = 'small',
  fullWidth = true,
  required = false,
  disabled = false,
  error = false,
  helperText = '',
  placeholder = 'None',
  getOptionLabel = (option) => option.name || option.label || option,
  getOptionValue = (option) => option.id || option.value || option,
  loading = false,
  renderOption = null,
  apiError = null,
}) => {
  if (apiError) {
    return (
      <Typography color='error' variant='body2'>
        Error loading {label.toLowerCase()}s
      </Typography>
    );
  }

  if (loading) {
    return (
      <Skeleton
        variant='rounded'
        height={size === 'small' ? 40 : 56}
        width='100%'
      />
    );
  }

  return (
    <FormControl
      size={size}
      sx={sx}
      fullWidth={fullWidth}
      required={required}
      error={error}>
      <InputLabel>{label}</InputLabel>
      <Select
        value={value}
        onChange={onChange}
        label={label}
        disabled={disabled}>
        <MenuItem value=''>
          <em>{placeholder}</em>
        </MenuItem>
        {options.map((option, index) => {
          const optionValue = getOptionValue(option);
          const optionLabel = getOptionLabel(option);

          return (
            <MenuItem key={optionValue || index} value={optionValue}>
              {renderOption ? renderOption(option) : optionLabel}
            </MenuItem>
          );
        })}
      </Select>
      {helperText && <FormHelperText>{helperText}</FormHelperText>}
    </FormControl>
  );
};

export default CpdDropdown;
